export default import.meta.ROLLUP_FILE_URL_kuARbO$FFaOQkGufyuPb5Q